/** @format */

import { notificationConstants } from '../notifications/notifications';
import { apiCall } from '../../core/apiCall';
import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const prefixesConstants = {
    LIST: 'prefixes_list',
    PREFIX_UPLOAD_LIST: 'prefix_upload_list',
};

export class prefixesActions extends defaultActions {
    static getPrefixesList = (url, filter) => {
        return (dispatch) => {
            apiCall
                .get(url, filter)
                .then((collections) => {
                    dispatch(success(collections));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(collections) {
            return { type: prefixesConstants.LIST, collections: collections };
        }

        function failure(error) {
            return { type: notificationConstants.ERROR };
        }
    };
}
